import { PAGE_SIZE } from '../const';

interface Config {
  row_index: number;
  size?: number;
  offset?: number;
}

export const convertToBarAutoAdBannerIndex = ({ row_index, size = PAGE_SIZE / 2, offset = 0 }: Config) => {
  return Math.floor((row_index - 3) / (2 * size)) + offset;
};
